<template>
  <el-dialog
    v-model="visible"
    :title="title"
    width="650px"
    center
    destroy-on-close
    class="legal-modal"
  >
    <div class="legal-content">
      <!-- 用户协议 -->
      <div v-if="type === 'terms'">
        <h3>1. 服务条款的确认与接受</h3>
        <p>欢迎使用 VideoInsight / MediaCrawler Pro 平台。本平台提供的各项服务和功能由本团队运营。请在注册或使用前仔细阅读以下条款。</p>
        
        <h3>2. 用户行为规范与合理使用</h3>
        <p>用户使用本平台进行视频解析、内容提取、AI 创作等操作时，必须遵守所在地法律法规。不得利用本平台从事侵犯他人著作权、商标权、隐私权或其他合法权益的操作。</p>
        
        <h3>3. 平台服务与免责声明</h3>
        <p>本平台聚合与提供的视频提取及分析工具仅供用户个人学习、科学研究及技术交流使用。用户提取并保存的内容其知识产权归原作者或许可方所有。</p>
        
        <h3>4. 服务变更与终止</h3>
        <p>平台保留随时修改、中断或终止部分或全部服务的权利。因不可抗力或第三方平台接口调整导致的服务中断，本平台不承担直接赔偿责任。</p>
      </div>

      <!-- 隐私政策 -->
      <div v-else-if="type === 'privacy'">
        <h3>1. 我们收集的信息</h3>
        <p>为向您提供账号管理、解析历史及任务队列服务，我们可能收集您的注册手机号、邮箱、操作日志及偏好设置。</p>
        
        <h3>2. 信息存储与安全</h3>
        <p>我们采用业界标准的安全加密传输（HTTPS）及本地离线存储隔离机制，确保您的个人凭证及数据安全。我们绝不会向任何未经授权的第三方出售或出租您的个人信息。</p>
        
        <h3>3. Cookie 与本地存储使用</h3>
        <p>平台仅在必要时使用 Cookie 或 LocalStorage 来保持您的登录会话状态与界面个性化配置。</p>

        <h3>4. 隐私权控制与注销</h3>
        <p>您有权随时查看、修改或申请注销您的账号及清除相关解析数据。</p>
      </div>

      <!-- 版权与免责声明 -->
      <div v-else-if="type === 'copyright'">
        <h3>1. 版权与知识产权归属</h3>
        <p>本平台涉及的抖音、B站、YouTube、小红书、快手等 20+ 平台的内容版权均归属各原平台及原创作者所有。本平台本身不存储、不出版、不传播未经授权的版权音视频文件。</p>

        <h3>2. 合理使用与免责条款</h3>
        <p>本工具仅供技术研究、学习交流与个人非商业性合理使用。使用者因侵权下载、二次传播或商业化利用引发的版权纠纷与法律责任，均由使用人自行承担，与本平台无关。</p>

        <h3>3. 侵权投诉与处理</h3>
        <p>若版权方认为本平台相关功能存在侵权隐患，请及时联系平台管理员，我们将第一时间配合核查与妥善处理。</p>
      </div>
    </div>
    <template #footer>
      <el-button type="primary" round @click="visible = false">我已阅读并知悉</el-button>
    </template>
  </el-dialog>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'

const props = defineProps<{
  type: 'terms' | 'privacy' | 'copyright'
}>()

const visible = ref(false)

const title = computed(() => {
  if (props.type === 'terms') return '用户服务协议'
  if (props.type === 'privacy') return '隐私政策与数据保护声明'
  return '版权与免责声明'
})

const open = () => {
  visible.value = true
}

defineExpose({
  open
})
</script>

<style scoped>
.legal-content {
  max-height: 420px;
  overflow-y: auto;
  padding: 0 16px;
  line-height: 1.6;
  color: #4a4a4a;
}
.legal-content h3 {
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 15px;
  color: #1a1a1a;
}
.legal-content p {
  margin-bottom: 12px;
  font-size: 13.5px;
}
</style>
